const getRecurrence = (plan_id: string, isSingleTime: boolean): string => {
  return plan_id === '165' ? 'yr' : plan_id !== '112' && isSingleTime ? 'pkg' : 'mo'
}

export default getRecurrence
